<!-- footer start-->
<div class="container-fluid">
  <div class="row">
    <div class="col-md-6 footer-copyright">
      <p class="mb-0">Copyright 2026 © Grupo Exito Todos os direitos reservados.</p>
    </div>

    <div class="col-md-6">
      <p class="pull-right mb-0">Gestão Estratégica</p>
    </div>
  </div>
</div>